export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-500px-8e4cced6a7f0934b511587d3a03eef03.svg";